import React, { useEffect } from 'react';
import {oyri_item} from '../../json/oyriItem';
import './OyRI.css';

const OYRI = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className='container'>
            <div className='row'>
                <h3 className='title'>Organización y Rediseño Institucional</h3>
                <hr className='hr-gob' />
                <h6>
                </h6>
            </div>
            <div className='row'>
                {
                    oyri_item.map((item, index) => (
                        <div key={index} className='col-md-3 col-sm-6 col-12'>
                            
                                 <div className='' >
                                    <a href={item.url} >
                                        <img src={"/assets/imgs/" + item.icono} className='card-img-top_oyri' alt='' />
                                    </a>
                                </div>
                                <br></br>

                            
                        </div>
                    ))
                }
            </div>
           
          
        </div>
    )
}

export default OYRI